module.exports = __webpack_public_path__ + "media/images/sales/early/bg-yellow-dotted-56526c20ab8827d056db3fd9d0f4ef26.png";